export interface ChatMessageLike {
  role: string;
  content?: string;
  status?: string;
}

/**
 * The user message to resubmit for retry/edit — the one whose assistant
 * reply either never arrived (empty content) or failed to produce a real
 * answer. "failed"/"error" covers the backend's fail-closed fallback
 * message, which has real (non-empty) content but isn't an actual answer.
 */
export function getRetryTargetMessage<T extends ChatMessageLike>(
  messages: T[]
): T | null {
  const lastMsg = messages[messages.length - 1];
  const isFailedAssistant =
    lastMsg?.role === "assistant" &&
    (lastMsg.content?.length === 0 ||
      lastMsg.status === "failed" ||
      lastMsg.status === "error");

  if (isFailedAssistant) {
    const priorUser = messages
      .slice(0, -1)
      .reverse()
      .find((m) => m.role === "user");
    return priorUser ?? null;
  }
  if (lastMsg?.role === "user") {
    return lastMsg;
  }
  return null;
}
